import { render, staticRenderFns } from "./asset-list.vue?vue&type=template&id=be0312b6&scoped=true&"
import script from "./asset-list.vue?vue&type=script&lang=ts&"
export * from "./asset-list.vue?vue&type=script&lang=ts&"
import style0 from "./asset-list.vue?vue&type=style&index=0&id=be0312b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0312b6",
  null
  
)

export default component.exports